<template>
<div class="chapter">
<div class="inner_page">
<div class="ded">
<p class="center">For Alex and Emma,<br/> who would have enjoyed the Sixties</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?4cd6e75c